import { UserInfo } from "@customTypes/mainState";

export const getUserInfoFromCookies = () => {
  if (document.cookie) {
    try {
      const cookies = document.cookie
        .split("; ")
        .reduce((prev: Record<string, string>, current) => {
          const [name, ...value] = current.split("=");
          prev[name] = value.join("=");
          return prev;
        }, {});
      if (!cookies.userInfo) throw new Error("No user info");

      const uncodedUserInfo = decodeURIComponent(cookies.userInfo);
      const pasrsedUserInfo = JSON.parse(uncodedUserInfo) as UserInfo;

      return pasrsedUserInfo;
    } catch (e) {
      console.warn();
      return undefined;
    }
  }

  return undefined;
};

export const returnToLogin = () => {
  document.cookie = "";
  window.location.reload();
};

type RunMode = "homologation" | "production" | "local";

export const getRunMode = (): RunMode => {
  const hostLocation = window.location.host;

  let runMode: RunMode = undefined;

  if (hostLocation.includes("astreasoftware")) {
    runMode = "production";
  } else if (hostLocation.includes("localhost")) {
    runMode = "local";
  } else {
    runMode = "homologation";
  }

  return runMode;
};
